import FontHeading3 from "../../../../components/fonts/font-heading3/font-heading3";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import {observer} from "mobx-react-lite";
import FlexSpaceBetweenWrapper
    from "../flex-space-between-wrapper/flex-space-between-wrapper";

interface IOfferedPlansTitle {
    title: string;
}

const OfferedPlansTitle: React.FC<IOfferedPlansTitle> = observer((IOfferedPlansTitle) => {
    return (
        <div className="offered-plans-title">
            <FlexSpaceBetweenWrapper>
                <div className="offered-plan-title-heading-text-wrapper">
                    <FontHeading3 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>
                        {IOfferedPlansTitle.title ? IOfferedPlansTitle.title : 'Offered Plans'}
                    </FontHeading3>
                </div>
            </FlexSpaceBetweenWrapper>
        </div>
    )
})

export default OfferedPlansTitle;